import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { UserThumbNailComponent } from '../user-thumb-nail/user-thumb-nail.component';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';

@Component({
    selector: 'app-liked-users-dialog',
    templateUrl: './liked-users-dialog.component.html',
    styleUrl: './liked-users-dialog.component.scss',
    imports: [CdkScrollable, MatDialogContent, UserThumbNailComponent, AssetUrlPipe]
})
export class LikedUsersDialogComponent {
constructor(public dialogRef:MatDialogRef<LikedUsersDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any
){}

ngOnInit() {
}

  close() {
    this.dialogRef.close(false);
  }
}
